import { EntitlementsContentParams } from '@sharefiledev/entitlements-pilet-sdk';

export interface FeatureBullet {
	text: string;
	iconPath: string;
}

export interface ActionButton {
	text: string;
	kind?: ActionButtonKind;
	urlPath: string;
}

export type EvaluationResult = EntitlementsContentParams;

export interface EvaluationResponse {
	results: EvaluationResult[];
}

/**
 * Defines the assets required to render a paywall modal.
 * - Use `content` to render modal content in a freeform manner with markdown and HTML support.
 * - Use a combination of `title`, `header`, `bullets`, and `footer` to render a structured modal.
 */
export interface PaywallModalContentResponse {
	content?: string;
	title?: string;
	header?: string;
	bullets?: FeatureBullet[];
	footer?: string;
	actionButton?: ActionButton;
	cancelButtonText: string;
	imagePath: string;
	adminNotifiedNotificationText?: string;
}

export interface PaywallBannerContentResponse {
	name: string;
	text: string;
	actionLink: {
		text: string;
		kind: ActionButtonKind;
		urlPath: string;
	};
	severity: string;
	additionalActionLink?: {
		text: string;
		kind: ActionButtonKind;
		urlPath: string;
	};
	adminNotifiedNotificationText?: string;
	isDismissible?: boolean;
}

export interface UserEmailInfo {
	userEmail: string;
	userFirstName: string;
	userLastName: string;
}

export enum NotificationType {
	NotifyAdmin = 'notifyAdmin',
}

export type NotificationRequest = {
	userRID: string;
	entitlementRID: string;
	entitlementDefRID: string;
	userEmail: string;
	userFirstName: string;
	userLastName: string;
	notificationType: NotificationType;
	limit: string;
	actionButtonLink: string;
	storageButtonLink?: string;
};

export type EvaluateRequest = {
	entitlementDefRID: string;
	current: string;
	requested: string;
};

export type EvaluateRequestContent = {
	userRID: string;
	evaluationRequests: EvaluateRequest[];
};

export enum ActionButtonKind {
	NotifyAdmin = 'notify-admin',
	UpgradePlan = 'upgrade-plan',
	BuyStorage = 'buy-storage',
	ViewStorage = 'view-storage',
	ShowModal = 'show-modal',
}
